/**
 * A que CANAL de upload um anexo do composer pertence, pela extensão —
 * spec-010-r2-guiada-pelo-agente-com-transcricao ([T006], US-4).
 *
 * Duas listas, cada uma espelho da fonte canônica do BACKEND que valida de
 * verdade (nenhuma redigitada aqui):
 * - carteira: `fee-fixo/constants/carteira-chat.js::EXTENSOES_ACEITAS`
 *   (espelho de `usecase_fee_fixo_carteira_chat`);
 * - transcrição: `constants/AnexoTranscricao.js::EXTENSOES_CANAL_TRANSCRICAO`
 *   (espelho de `aawz_transcriptions/utils/upload_texto_transcricao.py::
 *   EXTENSOES_ACEITAS`).
 *
 * Extensão fora das duas ⇒ nenhum canal — `iniciarUploadDoArquivo` (mixin de
 * upload) recusa ANTES de qualquer chamada de rede, com o nome do arquivo e
 * as DUAS listas na mensagem (`mensagemCanalDesconhecido`).
 */
import { getExtension } from '@modules/tarefas/utils/attachments'
import { EXTENSOES_ACEITAS as EXTENSOES_CANAL_CARTEIRA } from '@modules/fee-fixo/constants/carteira-chat'
import { EXTENSOES_CANAL_TRANSCRICAO } from '@modules/aawz-intelligence-v2/constants/AnexoTranscricao'

export const CANAL_CARTEIRA = 'carteira'
export const CANAL_TRANSCRICAO = 'transcricao'

/** `getExtension` devolve sem ponto e em minúsculas; as duas listas têm ponto. */
const comPonto = (extensaoSemPonto) =>
  extensaoSemPonto ? '.' + extensaoSemPonto : ''

/**
 * `'carteira' | 'transcricao' | null` — nunca escolhe entre os dois: as duas
 * listas são disjuntas (nenhuma extensão aparece nas duas).
 */
export const canalDoArquivo = (arquivo) => {
  const extensao = comPonto(getExtension((arquivo && arquivo.name) || ''))
  if (EXTENSOES_CANAL_CARTEIRA.indexOf(extensao) !== -1) return CANAL_CARTEIRA
  if (EXTENSOES_CANAL_TRANSCRICAO.indexOf(extensao) !== -1) {
    return CANAL_TRANSCRICAO
  }
  return null
}

/**
 * A frase que nomeia o arquivo e as DUAS listas aceitas — nunca "formato
 * inválido" sozinho, que não diz ao consultor o que enviar no lugar.
 */
export const mensagemCanalDesconhecido = (arquivo) => {
  const nome = (arquivo && arquivo.name) || 'arquivo sem nome'
  return (
    '"' +
    nome +
    '" não tem canal de envio. Envie carteira (' +
    EXTENSOES_CANAL_CARTEIRA.join(', ') +
    ') ou transcrição (' +
    EXTENSOES_CANAL_TRANSCRICAO.join(', ') +
    ').'
  )
}
